// extracted by mini-css-extract-plugin
export default {"msFooter":"RsFooter_msFooter__8jKPD","footerdescription":"RsFooter_footerdescription__FLDcs"};